import script from "./CieLabCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CieLabCard.vue?vue&type=script&setup=true&lang=js"

import "./CieLabCard.vue?vue&type=style&index=0&id=1880b62a&lang=less"

const __exports__ = script;

export default __exports__